import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden mx-auto" style={{ maxWidth: 'calc(100% - 48px)' }}>
      <div className="absolute inset-0 rounded-[28px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20red%20and%20black%20abstract%20background%20with%20subtle%20fire%20particles%2C%20cinematic%20atmosphere%2C%20mysterious%20vibe%2C%20dark%20gradient%20from%20deep%20crimson%20to%20black%2C%20minimalist%20elegant%20texture%2C%20theatrical%20stage%20lighting%20effect%2C%20no%20text%20or%20people&width=1800&height=1200&seq=hero-main-bg&orientation=landscape"
          alt="黑料视频 - 最新娱乐八卦爆料平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70 rounded-[28px]"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6 md:px-12 w-full">
        <Link
          to="/category/mingxing-heiliao"
          className="inline-flex items-center gap-1.5 px-5 py-2 rounded-full border border-white/40 text-white text-sm font-medium mb-6 hover:bg-white/10 transition-colors backdrop-blur-sm whitespace-nowrap"
        >
          <i className="ri-fire-line text-accent-400"></i>
          今日最热爆料
        </Link>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl">
          黑料24小时不打烊
        </h1>
        <p className="mt-4 md:mt-5 text-sm md:text-base text-white/75 max-w-xl leading-relaxed">
          国产黑料视频实时追踪，黑料女神攻略等热门内容<br className="hidden sm:block" />
          一站式浏览最新黑料爆料，吃瓜不迷路
        </p>
        <div className="flex items-center gap-4 mt-8">
          <Link
            to="/category/mingxing-heiliao"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
          >
            立即吃瓜
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 border border-white/50 text-white hover:bg-white/10 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}